export default __webpack_public_path__ + "static/img-schroders-distribution-datathon--mobile-d03cb39dd5bbd7acf98b1b11a44715ff.png";